import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject, combineLatest, map, takeUntil } from 'rxjs';
import { DoenkidsSessionProvider } from 'src/providers/session.provider';
import { PermissionProvider } from 'src/providers/permission.provider';
import { ThemeService } from 'src/app/core/services/theme.service';
import { AVAILABLE_THEMES } from 'src/app/core/config/themes';
import { OrganizationTheme } from 'src/app/core/models/theme.interface';
import { TEST_LOCATIONS } from 'src/providers/generic.provider';

@Component({
    selector: 'app-settings-overview',
    templateUrl: './settings-overview.component.html',
    styleUrls: ['./settings-overview.component.scss'],
    standalone: false
})
export class SettingsOverviewComponent implements OnDestroy {
  private stop$ = new Subject<void>();

  public isAdmin$: Observable<boolean>;

  public isCustomer$: Observable<boolean>;

  public hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$: Observable<boolean>;

  public showThemeSwitcher$: Observable<boolean>;

  public availableThemes = AVAILABLE_THEMES;
  public currentTheme$: Observable<OrganizationTheme>;

  constructor(
    private $session: DoenkidsSessionProvider,
    private $permission: PermissionProvider,
    private themeService: ThemeService,
  ) {
    this.isAdmin$ = this.$session.isAdmin$.pipe(takeUntil(this.stop$));
    this.isCustomer$ = this.$session.isCurrentOrganizationUnitIsOfTypeCustomer$.pipe(takeUntil(this.stop$));
    this.hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ = this.$permission.hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$.pipe(takeUntil(this.stop$));
    this.currentTheme$ = this.themeService.currentTheme$;

    const isTestLocation = TEST_LOCATIONS.includes(window.location.hostname);

    this.showThemeSwitcher$ = this.isAdmin$.pipe(
      map((isAdmin) => isAdmin && isTestLocation),
      takeUntil(this.stop$)
    );
  }

  onThemeChange(theme: OrganizationTheme): void {
    this.themeService.switchTheme(theme);
  }

  ngOnDestroy(): void {
    this.stop$.next();
  }
}
